type feedbackType = {
  localesMainChart: { [key: string]: string }
  localesActivities: { [key: string]: string }
  main: { [key: string]: string }
  feedback: {
    questions: [string, string]
    credits: [string, string][]
  }
}
export const DE: feedbackType = {
  localesMainChart: {
    residents: 'Erkrankte BewohnerInnen',
    staff: 'Erkranktes Personal',
    death: 'Todesfälle bis '
  },
  localesActivities: {
    groupactivities: 'Teilnehmer an Gruppenaktivitäten',
    participant: 'Teilnehmer'
  },
  main: {
    update: 'Aktualisiert am 21. März 2021',
    disclaimer:
      'Die folgende Grafik basiert auf den Daten aus dem Bericht des tessiner Kantonsarztes. Dieser stützt sich auf Tabellen des Altersheims, die teils unterschiedliche Zahlen enthalten. Es handelt sich daher nur um eine grafische Annäherung an die Geschehnisse.'
  },

  feedback: {
    questions: [
      'Wie informativ war der Beitrag?',
      'Wie gefällt Ihnen die Umsetzung?'
    ],
    credits: [
      ['Text und Recherche', 'Roland Gamp, Dominique Botti, Oliver Zihlmann'],
      ['Umsetzung', 'Sebastian Broschinski']
    ]
  }
}

export const FR: feedbackType = {
  localesMainChart: {
    residents: 'Résidents EMS infectés',
    staff: 'Employés EMS infectés',
    death: 'Décès au '
  },
  localesActivities: {
    groupactivities: 'Participants aux activités récréatives en groupe',
    participant: 'Participant'
  },
  main: {
    update: 'Mis à jour le 21 mars 2021',
    disclaimer:
      "Le graphique suivant se base sur le rapport du Médecin cantonal tessinois. Ce dernier se base sur les chiffres livrés par la direction de l'EMS Il Circolo del Ticino qui sont parfois différents. Le graphique exprime cette approximation."
  },

  feedback: {
    questions: [
      'Cet article vous a-t-il informé?',
      'Comment trouvez-vous la mise en page?'
    ],
    credits: [
      ['Texte et enquête', 'Roland Gamp, Dominique Botti, Oliver Zihlmann'],
      ['Graphisme et mise en page', 'Sebastian Broschinski']
    ]
  }
}
